import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ProjectBreadCrumbsFacade } from '@mitsubishi/project/data-access';
import { PageHeaderComponent } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-chiller-free-st-shell',
  imports: [RouterOutlet, PageHeaderComponent, ApmTranslatePipe],
  templateUrl: './chiller-free-st-shell.component.html',
  styleUrl: './chiller-free-st-shell.component.scss',
})
export class ChillerFreeStShellComponent {
  projectBreadCrumbsFacade = inject(ProjectBreadCrumbsFacade);

  breadcrumbs = this.projectBreadCrumbsFacade.breadcrumbs;
}
